import React from "react";
import styled from "styled-components";
import moment from "moment";
import { FooterSection } from "@sonder/ui/source/styled/components/DateTimePicker";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { borders } from "@sonder/ui/source/styled/theme";

const NO_TIME_CALENDAR_SPEC = {
  sameDay: "[Today]",
  nextDay: "[Tomorrow]",
  lastDay: "[Yesterday]",
  nextWeek: "MMM D",
  lastWeek: "MMM D",
  sameElse: "MMM D",
};

const WITH_TIME_CALENDAR_SPEC = {
  sameDay: "[Today at] ha",
  nextDay: "[Tomorrow at] ha",
  lastDay: "[Yesterday at] ha",
  nextWeek: "MMM D [at] ha",
  lastWeek: "MMM D [at] ha",
  sameElse: "MMM D [at] ha",
};

const SameDayTurnText = styled.div`
  margin-top: 0.25rem;
`;

const StyledFooterSection = styled(FooterSection)`
  align-items: center;
  border-bottom: ${borders.standard};
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem;
`;

interface SetNextTurnoverRowProps {
  bookingInfo: BookingInfo | null | undefined;
  closestFutureCheckout: moment.Moment;
  onHandleApply(nextDate: moment.Moment, shouldClose?: boolean): void;
  selectedDate: moment.Moment | null;
}

export const SetNextTurnoverRow = ({
  bookingInfo,
  closestFutureCheckout,
  onHandleApply,
  selectedDate,
}: SetNextTurnoverRowProps) => {
  const upcomingCheckInTime = bookingInfo?.upcomingBooking?.checkInTime;
  const isUpcomingBookingOnCheckoutDate =
    upcomingCheckInTime &&
    moment(upcomingCheckInTime).isSame(closestFutureCheckout, "day");

  const calendarSpec = isUpcomingBookingOnCheckoutDate
    ? WITH_TIME_CALENDAR_SPEC
    : NO_TIME_CALENDAR_SPEC;

  const nextCheckoutTime = isUpcomingBookingOnCheckoutDate
    ? moment(upcomingCheckInTime)
    : closestFutureCheckout;

  const nextCheckoutText = nextCheckoutTime.calendar(moment(), calendarSpec);

  const onClick = () => {
    const selectedWithDefault = selectedDate || moment();

    const newDueAt = isUpcomingBookingOnCheckoutDate
      ? moment(upcomingCheckInTime)
      : closestFutureCheckout
          .set("hours", selectedWithDefault.hours())
          .set("minutes", selectedWithDefault.minutes())
          .set("seconds", selectedWithDefault.seconds());

    onHandleApply(newDueAt, true);
  };

  return (
    <StyledFooterSection>
      <div>
        <b>Set as Next Turnover:</b>
        {isUpcomingBookingOnCheckoutDate && (
          <SameDayTurnText>Same Day Turn</SameDayTurnText>
        )}
      </div>
      <Button onClick={onClick}>{nextCheckoutText}</Button>
    </StyledFooterSection>
  );
};
